/* eslint-disable  */
// @ts-nocheck
import * as React from 'react';
import {
  Box,
  Typography,
  Button,
  IconButton,
  InputLabel,
  TextField,
  OutlinedInput,
  InputAdornment,
  Paper,
  Link,
  FormHelperText,
} from '@mui/material';
import MainLogo from '../../../components/MainLogo/MainLogo.components';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useLogin } from '../hooks/useLogin';

const ChangePassword = ({ setChng, email }: { setChng: (arg0: any) => void; email: string }) => {
  // Start Input Password Code
  interface State {
    amount: string;
    password: string;
    weight: string;
    weightRange: string;
    showPassword: boolean;
  }
  const [values, setValues] = React.useState<State>({
    amount: '',
    password: '',
    weight: '',
    weightRange: '',
    showPassword: false,
    showNewPassword: false,
  });
  const handleChange = (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
    setValues({ ...values, [prop]: event.target.value });
  };
  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };
  const handleClickShowNewPassword = () => {
    setValues({
      ...values,
      showNewPassword: !values.showNewPassword,
    });
  };
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const validationSchema = yup.object({
    email: yup.string().email('Enter a valid email').required('Email is required'),
    password: yup
      .string()
      .min(8, 'Password should be of minimum 8 characters length')
      .required('Password is required'),
    newPassword: yup
      .string()
      .oneOf([yup.ref('password'), null], 'Passwords must match')
      .min(8, 'Password should be of minimum 8 characters length')
      .required('New Password is required'),
    otp: yup.string().required('Code is required'),
  });

  const { getPasswordOtp, changePassword } = useLogin();

  const formik = useFormik({
    initialValues: {
      email,
      password: '',
      newPassword: '',
      otp: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      changePassword(values, setChng);
      // alert(JSON.stringify(values, null, 2));
    },
  });

  // End Input Password Code
  return (
    <form onSubmit={formik.handleSubmit}>
      <Paper className="UpdateEmailBox" style={{ marginTop: 10 }}>
        <Paper>
          <Typography variant="h6" className="AccountHeading">
            <b>Change Password</b>
            <Typography variant="body2" sx={{ mt: 2 }}>
              Check your inbox, we sent a code to {email}
            </Typography>
          </Typography>
          <Paper className="CurrentEmailBox">
            <Box className="CommonFormControl" sx={{ mt: 3 }}>
              <InputLabel className="PasswordLabelBox">
                New Password * <span className="ForgotPassword">Minimum 8 characters</span>
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-password"
                type={values.showPassword ? 'text' : 'password'}
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                error={formik.touched.password && Boolean(formik.errors.password)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {values.showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Password"
              />
              <FormHelperText
                style={{ color: '#D3314C' }}
                error={formik.touched.password && formik.errors.password}
                id="accountId-error"
              >
                {formik.errors.password}
              </FormHelperText>
            </Box>
            <Box className="CommonFormControl">
              <InputLabel className="PasswordLabelBox">
                Confirm New Password * <span className="ForgotPassword">Minimum 8 characters</span>
              </InputLabel>
              <OutlinedInput
                id="outlined-adornment-password"
                type={values.showNewPassword ? 'text' : 'password'}
                name="newPassword"
                value={formik.values.newPassword}
                onChange={formik.handleChange}
                error={formik.touched.newPassword && Boolean(formik.errors.newPassword)}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowNewPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {values.showNewPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Confirm New Password"
              />
              <FormHelperText
                style={{ color: '#D3314C' }}
                error={formik.touched.newPassword && formik.errors.newPassword}
                id="accountId-error"
              >
                {formik.errors.newPassword}
              </FormHelperText>
            </Box>
          </Paper>
          <Paper className="OtpCodeBox">
            <Box className="CommonFormControl" sx={{ mt: 3 }}>
              <InputLabel>Code *</InputLabel>
              <TextField
                label=""
                variant="outlined"
                name="otp"
                value={formik.values.otp}
                onChange={formik.handleChange}
                error={formik.touched.otp && Boolean(formik.errors.otp)}
                helperText={formik.touched.otp && formik.errors.otp}
              />
            </Box>
            <Box>
              <Typography variant="body1">
                Didn’t get a code? <Link onClick={() => getPasswordOtp()}>Resend code</Link>
              </Typography>
            </Box>
          </Paper>
          <Box className="FooterButton" sx={{ mt: 4 }}>
            <Button
              className="CommonModalButton FullWidthButton"
              color="primary"
              variant="outlined"
              onClick={() => {
                formik.resetForm();
                setChng(null);
              }}
            >
              Cancel
            </Button>
            <Button
              className="CommonModalButton FullWidthButton"
              color="primary"
              variant="contained"
              type="submit"
            >
              Continue
            </Button>
          </Box>
        </Paper>
      </Paper>
    </form>
  );
};

export default ChangePassword;
